import { render, staticRenderFns } from "./DetailShipper.vue?vue&type=template&id=c000f020"
import script from "./DetailShipper.vue?vue&type=script&lang=js"
export * from "./DetailShipper.vue?vue&type=script&lang=js"
import style0 from "./DetailShipper.vue?vue&type=style&index=0&id=c000f020&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports